import { useEffect, useState, useContext } from "react";
import { baseUrl } from "../../connections";
import { UserContext } from "../../context/UserContext";

export const useSubCategory = () => {
  const { userDetails } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [payload, setSubCatPayload] = useState(null);
  const [paramBrandid, setSubParam] = useState("");
  const [paramCatid, setCatParam] = useState("");

  useEffect(() => {
    // Don't fetch until user is authenticated — sub_category/lists API requires user_uuid
    if (!userDetails?.uuid) return;
    if (!payload && paramCatid === "" && paramBrandid === "") return;
    setData([]);
    setIsLoading(true);

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("x-auth-token", userDetails?.token);

    const params = JSON.stringify(payload);

    const requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };
    const userId = userDetails?.uuid ?? "";
    const payloadStr = payload ? `&${payload}` : "";
    let url = "";
    if (paramCatid !== "" && paramBrandid !== "") {
      url = `${baseUrl}/sub_category/lists?user_uuid=${userId}&category_uuid=${paramCatid}&brand_uuid=${paramBrandid}${payloadStr}`;
    } else if (paramCatid !== "") {
      url = `${baseUrl}/sub_category/lists?user_uuid=${userId}&category_uuid=${paramCatid}${payloadStr}`;
    } else if (paramBrandid !== "") {
      url = `${baseUrl}/sub_category/lists?user_uuid=${userId}&brand_uuid=${paramBrandid}${payloadStr}`;
    } else {
      url = `${baseUrl}/sub_category/lists?user_uuid=${userId}${payloadStr}`;
    }

    fetch(`${url}`, requestOptions)
      .then(async (response) => {
        const res = await response.text();
        if (response.status !== 200) {
          throw res;
        }
        return JSON.parse(res);
      })
      .then((result) => {
        result.sort((a, b) => {
          return a.sort_order - b.sort_order;
        });
        setData([...result]);
        setError(false);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [payload, paramBrandid, paramCatid]);

  return {
    subCategoryList: data,
    isCatLoading: isLoading,
    catError: error,
    setSubCatPayload,
    setSubParam,
    setCatParam,
  };
};
